"use client";

import Script from "next/script";

import { useConfig } from "@jti/app-context/useConfig";

export function TrustPilot() {
  const { scriptPath, isEnabledForTenant } = useConfig();

  if (!isEnabledForTenant || !scriptPath) {
    return (
      <div hidden data-testid="trustpilot-fallback" data-debug={`${isEnabledForTenant}, ${scriptPath}`}>
        TrustPilot not configured
      </div>
    );
  }

  return <Script src={scriptPath} strategy="afterInteractive" />;
}
